import type { IconSvgObject } from './types';

const ArrowUpRight01Icon: IconSvgObject = [
  ["path", { d: "M17.5 15V6.5H9.00003M17.0714 6.9286L6.50003 17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ArrowUpRight01Icon;
